<template>
  <div class="quote-total-section">
    <div class="sk-heading-small-semibold quote-total-section__tax-excluded">
      <span class="quote-total-section__label">
        {{ $t('quote_details_unique_pricing.totals_section.excluding_taxes') }}
      </span>
      <span>
        {{ excludedTaxTotalAmount }}
      </span>
    </div>
    <div class="quote-total-section__tax-amounts">
      <div class="quote-total-section__tax-amounts__row">
        <span class="sk-text-medium-regular text--grey quote-total-section__label">
          {{ $t(
            'quote_details_unique_pricing.totals_section.subscription_tax_amount',
            { taxPercentage }
          ) }}
        </span>
        <span class="sk-text-medium-regular text--grey">
          {{ subscriptionTaxAmount }}
        </span>
      </div>
      <div
        v-if="chargesTaxAmount"
        class="quote-total-section__tax-amounts__row"
      >
        <span class="sk-text-medium-regular text--grey quote-total-section__label">
          {{ $t(
            'quote_details_unique_pricing.totals_section.charges_tax_amount',
            { taxPercentage }
          ) }}
        </span>
        <span class="sk-text-medium-regular text--grey">
          {{ chargesTaxAmount }}
        </span>
      </div>
    </div>
    <div class="quote-total-section__total-amount-with-taxes">
      <span class="sk-text-medium-regular quote-total-section__label">
        {{ $t('quote_details_unique_pricing.totals_section.total_amount_with_taxes') }}
      </span>
      <span class="sk-text-medium-regular">
        {{ totalAmountWithTax }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuoteTotalSection',
  props: {
    excludedTaxTotalAmount: {
      type: String,
      required: true,
    },
    subscriptionTaxAmount: {
      type: String,
      required: true,
    },
    chargesTaxAmount: {
      type: [String, null],
      default: null,
    },
    totalAmountWithTax: {
      type: String,
      required: true,
    },
    taxPercentage: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.quote-total-section {
  display: flex;
  flex-direction: column;
  padding: 0 16px 24px 16px;
  gap: 8px;
}

.quote-total-section__tax-excluded {
  display: flex;
  gap: 12px;
}

.quote-total-section__label {
  flex: 1;
}

.quote-total-section__tax-amounts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quote-total-section__tax-amounts__row {
  display: flex;
  gap: 24px;
}

.quote-total-section__tax-amounts__row span:first-child {
  flex: 1;
}

.quote-total-section__total-amount-with-taxes {
  display: flex;
  gap: 12px;
}
</style>
